import React from "react";
import { styled } from "@mui/material/styles";
import TextField, { TextFieldProps } from "@mui/material/TextField";

const FmTextFieldManaged = styled(
    React.forwardRef<any, TextFieldProps>((props, ref) => {
        return <TextField type={props.type} inputRef={ref} spellCheck={false} autoComplete='off' {...props} />;
    })
)(({ theme }: any) => ({
    ".MuiInputBase-root": {
        minHeight: "60px",
        paddingBottom: "10px",
    },
    "& .MuiFormHelperText-root": {
        marginLeft: "2px",
        fontSize: "14px",
        color: "#E11919",
        lineHeight: "16px",
        position: "absolute",
        top: "64px",
    },
    "& .Mui-error ~ .MuiFilledInput-root ": {
        backgroundColor: "#FEE8E8",
        boxShadow: "none",
        "&:hover, &:not(:hover) ": {
            backgroundColor: "#FEE8E8",
        },
    },

    "& .MuiInputLabel-root": {
        color: "#424242",
        opacity: "0.5",
        fontSize: "18px",
        letterSpacing: 0,
        lineHeight: "19px",
        backgroundColor: "transparent",
        marginTop: "7px",
    },

    "& .MuiInputLabel-shrink": {
        color: theme.palette.primary.main,
        fontSize: "18px",
        fontWeight: "bold",
        lineHeight: "14px",
        letterSpacing: 0,
        opacity: "1",
        backgroundColor: "transparent",
        marginTop: "4px",
        overflow: "visible ",
    },
    "& .MuiFilledInput-root": {
        border: "none",
        overflow: "hidden",
        borderRadius: 6,
        backgroundColor: "#FFF",
        letterSpacing: 0,
        lineHeight: "19x",
        boxShadow: (theme as any).boxShadow.primary,
        transition: theme.transitions.create(["border-color", "background-color", "box-shadow"]),
        "& .MuiInputBase-input": {},
        "&:hover": {
            backgroundColor: "#FFF",
        },
        "&:not(:hover)": {
            backgroundColor: "#FFF",
        },
        "&:focus": {
            backgroundColor: "#FFF",
        },
        "& .Mui-disabled": {
            backgroundColor: "#F5F7FB",
            "&:hover": {
                backgroundColor: "#F5F7FB",
            },
        },
        "& .Mui-focused": {
            backgroundColor: "#FFF",
            boxShadow: (theme as any).boxShadow.primary,
            border: "0.56px solid #00833E",
        },
    },
}));

export default FmTextFieldManaged;
